angular
    .module('WizApp')
    .component('loginForm', {
        controller: [
            '$scope',
            '$window',
            'AuthenticationService',
            'AnalyticsService',
            'NoticeService',
            'ErrorFactory',
            'EVENT_NAMES',
            'WizAppAnalyticsService',
            'CookiesConsentService',
            function ($scope, $window, AuthenticationService, AnalyticsService, NoticeService, ErrorFactory, EVENT_NAMES, WizAppAnalyticsService, CookiesConsentService) {
                const vm = this;

                vm.username = null;
                vm.password = null;

                vm.formLoading = false;
                vm.facebookLoading = false;
                vm.googleLoading = false;

                vm.invalidCredentials = false;

                vm.forgottenPasswordMode = false;
                vm.forgottenPasswordMailSent = false;

                vm.facebookCookieActivator = false;
                vm.googleCookieActivator = false;
                vm.facebookActivated = false;
                vm.googleActivated = false;

                vm.onSubmit = onSubmit;
                vm.toggleForgottenPassword = toggleForgottenPassword;
                vm.isAnythingLoading = isAnythingLoading;
                vm.handleCookieActivatorClick = handleCookieActivatorClick;

                vm.resetCredentialsValidity = () => { vm.invalidCredentials = false };

                $scope.$on(EVENT_NAMES.facebookConnect.start, () => {
                    vm.facebookLoading = true;
                });

                $scope.$on(EVENT_NAMES.facebookConnect.success, () => {
                    AnalyticsService
                        .send({ event: 'Register', category: 'Facebook', label: 'Register Job' })
                        .finally(function () {
                            $window.location.href = '/';
                        });
                });

                $scope.$on(EVENT_NAMES.facebookConnect.error, () => {
                    vm.facebookLoading = false;
                });


                $scope.$on(EVENT_NAMES.googleConnect.start, () => {
                    vm.googleLoading = true;
                });

                $scope.$on(EVENT_NAMES.googleConnect.success, () => {
                    AnalyticsService
                        .send({ event: 'Register', category: 'Google', label: 'Register Job' })
                        .finally(function () {
                            $window.location.href = '/';
                        });
                });

                $scope.$on(EVENT_NAMES.googleConnect.error, () => {
                    vm.googleLoading = false;
                });

                $scope.$on(EVENT_NAMES.facebookConnect.cookieActivator, () => {
                    vm.facebookCookieActivator = true;
                    vm.googleCookieActivator = false;
                });

                $scope.$on(EVENT_NAMES.googleConnect.cookieActivator, () => {
                    vm.googleCookieActivator = true;
                    vm.facebookCookieActivator = false;
                });

                $scope.$on('$destroy', () => {
                    WizAppAnalyticsService.resetGaPage();
                });

                function onSubmit() {
                    if (vm.isAnythingLoading()) {
                        return;
                    }

                    if (vm.forgottenPasswordMode) {
                        submitForgottenPassword();
                        return;
                    }

                    vm.formLoading = true;

                    const { username, password } = vm;

                    AuthenticationService
                        .loginAccount({ email: username, password })
                        .then(response => response.data)
                        .then(data => {

                            $window.location.href = AuthenticationService.getRedirectRoute(data.redirect, true);
                        })
                        .catch(error => {
                            if (error.status === 403) {
                                vm.invalidCredentials = true;
                            } else {
                                NoticeService.error('A problem has occurred');
                            }

                            vm.formLoading = false;
                        });
                }

                function submitForgottenPassword() {
                    vm.formLoading = true;

                    AuthenticationService
                        .resetPassword(vm.username)
                        .then(response => response.data)
                        .then(() => {
                            vm.forgottenPasswordMailSent = true;
                        })
                        .catch(error => {
                            const status = error.status;
                            if (angular.isNumber(status) && status >= 400 && status < 500) {
                                vm.invalidCredentials = true;
                            } else {
                                // TODO translate this
                                NoticeService.error('Oups, une erreur est survenue :/');
                            }
                        })
                        .finally(() => { vm.formLoading = false });
                }

                function toggleForgottenPassword() {
                    vm.forgottenPasswordMode = !vm.forgottenPasswordMode;
                }

                function isAnythingLoading() {
                    return vm.formLoading || vm.facebookLoading || vm.googleLoading;
                }

                function handleCookieActivatorClick(specificConsent) {
                    switch (specificConsent) {
                        case 'facebook':
                            CookiesConsentService.setCookiesConsent({ connect_facebook: true });
                            vm.facebookActivated = true;
                            vm.googleActivated = false;
                            break;
                        case 'google':
                            CookiesConsentService.setCookiesConsent({ connect_google: true });
                            vm.googleActivated = true;
                            vm.facebookActivated = false;
                            break;
                        default:
                            return null;
                    }
                }

                (() => {
                    WizAppAnalyticsService.trackPageView('/login');
                })();
            }
        ],
        // language=HTML
        template:
                `
            <form
                data-ng-submit="$ctrl.onSubmit()"
            >
                <form-control
                    type="email"
                    input-id="login_username"
                    name="email"
                    input-class="form-control form-control--big"
                    ng-model="$ctrl.username"
                    label-class="font-size-tiny"
                    label-text="{{ 'wizbii.onboarding.messages.form.label.email' | trans }}"
                    required
                    on-change="$ctrl.resetCredentialsValidity()"
                ></form-control>

                <form-control
                    ng-if="!$ctrl.forgottenPasswordMode"
                    type="password"
                    input-id="login_password"
                    name="password"
                    input-class="form-control form-control--big"
                    ng-model="$ctrl.password"
                    label-class="font-size-tiny"
                    label-text="{{ 'wizbii.onboarding.messages.form.label.password' | trans }}"
                    required
                    on-change="$ctrl.resetCredentialsValidity()"
                ></form-control>

                <div
                    ng-if="$ctrl.invalidCredentials"
                    class="text-error font-weight-medium text-center"
                >
                    <span ng-if="!$ctrl.forgottenPasswordMode">{[:: 'wizbii.registerlayer.messages.form.invalidcredentials' | trans]}</span>
                    <span ng-if="$ctrl.forgottenPasswordMode">{[:: 'wizbii.registerlayer.messages.label.mailnotbind' | trans ]}</span>
                </div>

                <div
                    class="font-weight-medium text-center"
                    ng-if="$ctrl.forgottenPasswordMode && $ctrl.forgottenPasswordMailSent"
                >
                    {[:: 'wizbii.registerlayer.messages.label.lostpasswordsent' | trans ]}
                </div>

                <button
                    type="submit"
                    class="button button--secondary button--block margin-top-gutter margin-top-large--sm-up"
                    data-ng-disabled="$ctrl.isAnythingLoading() || ($ctrl.forgottenPasswordMode && $ctrl.forgottenPasswordMailSent)"
                >
                    <span ng-if="!$ctrl.forgottenPasswordMode">{[:: 'wizbii.profile.messages.title.connexion' | trans ]}</span>
                    <span ng-if="$ctrl.forgottenPasswordMode">{[:: 'wizbii.registerlayer.messages.label.retrievepassword' | trans ]}</span>
                </button>

                <div class="text-center margin-top-gutter-ish">
                    <a
                        class="link font-weight-medium"
                        data-ng-click="$ctrl.toggleForgottenPassword()"
                        data-ng-disabled="$ctrl.isAnythingLoading()"
                    >
                        <span ng-if="!$ctrl.forgottenPasswordMode">{[:: 'wizbii.onboarding.messages.message.motdepasseoublie' | trans ]}</span>
                        <span ng-if="$ctrl.forgottenPasswordMode">{[:: 'wizbii.registerlayer.messages.label.rememberpassword' | trans ]}</span>
                    </a>
                </div>

                <div class="side-separators text-center margin-top-large margin-bottom-large">
                    <span class="padding-left-inner padding-right-inner">{[:: 'wizbii.core.messages.word.or'|trans|lowercase ]}</span>
                </div>

                <div class="row">
                    <div class="col col-xs-12 col-sm-6">
                        <facebook-connect></facebook-connect>
                    </div>

                    <div class="col col-xs-12 col-sm-6">
                        <google-connect></google-connect>
                    </div>
                </div>

                <div class="padding-top-gutter text-center font-size-base-small-down">
                    <span data-ng-if="$ctrl.facebookCookieActivator && !$ctrl.facebookActivated">
                        {[:: 'wizbii.onboarding.messages.form.error.facebookconsent'|trans ]}
                        <a data-ng-click="$ctrl.handleCookieActivatorClick('facebook')">{[:: 'wizbii.onboarding.messages.form.error.consentlink'|trans ]}</a>
                    </span>
                    <span data-ng-if="$ctrl.googleCookieActivator && !$ctrl.googleActivated">
                        {[:: 'wizbii.onboarding.messages.form.error.googleconsent'|trans ]}
                        <a data-ng-click="$ctrl.handleCookieActivatorClick('google')">{[:: 'wizbii.onboarding.messages.form.error.consentlink'|trans ]}</a>
                    </span>
                    <span data-ng-if="$ctrl.facebookActivated">
                        {[:: 'wizbii.onboarding.messages.form.error.facebookactivated'|trans ]}
                    </span>
                    <span data-ng-if="$ctrl.googleActivated">
                        {[:: 'wizbii.onboarding.messages.form.error.googleactivated'|trans ]}
                    </span>
                </div>
            </form>
        `
    });
